export default "__VITE_ASSET__B6r9tSOy__"